/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Thumbnail_Prompt_YesInputs */

const en_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, generate`)
};

const fr_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, générer`)
};

const de_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, generieren`)
};

const it_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, genera`)
};

const ru_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, генерировать`)
};

const es_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, generar`)
};

const zh_cn2_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，生成`)
};

const ja_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、生成します`)
};

const hi_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हाँ, उत्पन्न करें`)
};

const pt_pt2_scene_change_detection_thumbnail_prompt_yes = /** @type {(inputs: Scene_Change_Detection_Thumbnail_Prompt_YesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, gerar`)
};

/**
* | output |
* | --- |
* | "Yes, generate" |
*
* @param {Scene_Change_Detection_Thumbnail_Prompt_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_prompt_yes = /** @type {((inputs?: Scene_Change_Detection_Thumbnail_Prompt_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Prompt_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "de") return de_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "it") return it_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "ru") return ru_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "es") return es_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "ja") return ja_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "hi") return hi_scene_change_detection_thumbnail_prompt_yes(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_thumbnail_prompt_yes(inputs)
	return en_scene_change_detection_thumbnail_prompt_yes(inputs)
});